import React from 'react';
import { ModalBox } from '../../partials/ModalBox';
import * as S from './styled';
export const SummaryModal = ({ title, items, onClose }) => {
    return (React.createElement(ModalBox, { title: title, onClose: onClose }, items.map(({ label, content }) => (React.createElement(S.Item, null,
        React.createElement(S.ItemLabel, null, label),
        React.createElement(S.ItemContent, null, content))))));
};
